import React from 'react';
import style from './style.module.css';
import colors from 'design-v2/globals/colors/colors.module.css';
import { IGenericError } from 'design-v2/common/GenericError/types';
import {
  Button,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import classNames from 'classnames';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { AlertTitle } from '@material-ui/lab';
import { ToastType } from 'shared-types/SharedTypes';

const NS = 'GenericError';

export default function GenericError(props: IGenericError) {
  const {
    errorTitle,
    errorDetail,
    accordionTitle,
    accordionDetail,
    insert1,
    errorSeverity,
    extraButtonText,
    extraButtonClickHandler,
    secondButtonText,
    secondButtonClickHandler,
  } = props;

  const [expanded, setExpanded] = React.useState<boolean>(false);
  const handleChange = () => {
    setExpanded(!expanded);
  };
  return (
    <Alert
      className={classNames({
        [style.alertPanel]: true,
        [colors.bgClrBadDark]: errorSeverity === ToastType.error,
        [colors.bgClrInfoDark]: errorSeverity === ToastType.info,
      })}
      icon={<></>}
      severity={errorSeverity || 'error'}
    >
      <AlertTitle>
        <Alert
          action={
            <>
              {!!extraButtonText && (
                <div className={style.extraBtnWrap}>
                  <Button color="inherit" size="small" onClick={extraButtonClickHandler}>
                    <span dangerouslySetInnerHTML={{ __html: extraButtonText }} />
                  </Button>
                </div>
              )}
              {!!secondButtonText && (
                <div className={style.extraBtnWrap}>
                  <Button color="inherit" size="small" onClick={secondButtonClickHandler}>
                    <span dangerouslySetInnerHTML={{ __html: secondButtonText }} />
                  </Button>
                </div>
              )}
            </>
          }
          className={classNames({
            [style.alertTitle]: true,
            [colors.bgClrBadDark]: errorSeverity === ToastType.error,
            [colors.bgClrInfoDark]: errorSeverity === ToastType.info,
          })}
          icon={
            <ErrorOutlineIcon
              className={classNames({
                [style.textColor]: true,
                [style.errorIcon]: true,
              })}
            />
          }
          severity={errorSeverity || 'error'}
        >
          <AlertTitle>{errorTitle}</AlertTitle>
          <span dangerouslySetInnerHTML={{ __html: errorDetail }} />
        </Alert>
      </AlertTitle>

      {insert1}

      {accordionTitle && (
        <ExpansionPanel
          className={classNames({
            [style.accordionPanel]: true,
          })}
          expanded={expanded}
          onChange={handleChange}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className={classNames({
              [style.accordionTitle]: true,
            })}
          >
            {accordionTitle}
          </ExpansionPanelSummary>
          <ExpansionPanelDetails
            className={classNames({
              [style.accordionDetailPanel]: true,
              [style.accordionDetailPanelIsError]: errorSeverity === ToastType.error,
              [style.accordionDetailPanelIsInfo]: errorSeverity === ToastType.info,
              [style.textColor]: true,
            })}
          >
            <Typography>{accordionDetail}</Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      )}
    </Alert>
  );
}
